import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Col, Popconfirm, Row, Timeline, Collapse } from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  CaretRightOutlined,
} from "@ant-design/icons";
import { DATE_FORMAT, INFO_ELIMINAR } from "../../../utils";

import {
  isActiveExpLaboral,
  removeExpLaboralById,
} from "../../../redux/aspirante/expLaboralDuck";
import { InfoAcademica } from "./HisAcademico";
import moment from "moment";

const { Panel } = Collapse;

/**
 * Componente para mostrar el Timeline de la experiencia laboral del aspirante
 * @returns JSX
 */
export const HisExpLaboral = ({ showModal, form, setActFechaFin }) => {
  const dispatch = useDispatch();
  const { expLaboral } = useSelector((state) => state.expLaboral);
  const { bloquearPorFecha } = useSelector((state) => state.bloqueoEstatus);
  const { areasExperiencia, remuneraciones } = useSelector(
    (state) => state.catalogos
  );
  const { estatusPostulacion } = useSelector(
    (state) => state.bloqueoEstatus.concurso
  );

  /**
   * Función para obtener la descripción de una area de experiencia
   * @param {number} idArea
   */
  const obtenerDescExperiencia = (idArea) =>
    areasExperiencia.find(({ areaId }) => areaId === +idArea)?.nombre;

  /**
   * Función para obtener la descripción de una remuneración
   * @param {number} idRemuneracion
   */

  const obtenerDescRemuneracion = (id) =>
    remuneraciones.find(({ remuneracionId }) => remuneracionId === +id)
      ?.remuneracion;

  /**
   * Función que elimina un registro de la lista
   * @param {number} id
   */
  const eliminarRegistroExpLaboral = (id) => {
    dispatch(removeExpLaboralById(id));
  };

  /**
   * Función que manda los valores al formulario del modal para su respectiva edición
   * @param {object} experiencia object del formulario del modal
   */
  const editarExpLaboral = (experiencia) => {
    dispatch(isActiveExpLaboral(experiencia));

    form.setFieldsValue({ cargo: experiencia.nombreCargo });
    form.setFieldsValue({ area: String(experiencia.idAreaExp) });
    form.setFieldsValue({ empresa: experiencia.nombreEmpresa });
    form.setFieldsValue({ remuneracion: String(experiencia.idRemuneracion) });
    form.setFieldsValue({ funciones: experiencia.funciones });
    form.setFieldsValue({ actual: experiencia.expActual });

    form.setFieldsValue({ fhini: moment(experiencia.fhInicio) });
    experiencia.fhFin &&
      form.setFieldsValue({ fhfin: moment(experiencia.fhFin) });

    setActFechaFin(experiencia.expActual === 1 ? true : false);
    showModal();
  };

  return (
    <div className="fondo-academico">
      <Timeline id="timeLine" style={{ marginTop: 10 }}>
        {expLaboral.map((item, i) => (
          <Timeline.Item key={i}>
            <Row gutter={24}>
              <Col span={20}>
                <div className="titulo-academico">{item.nombreCargo}</div>
              </Col>
              <Col>
              {!bloquearPorFecha && !estatusPostulacion && (
                  <>
                    <Button
                      id="bntCircle"
                      shape="circle"
                      icon={<EditOutlined />}
                      onClick={() => editarExpLaboral(item)}
                    />{" "}
                    <Popconfirm
                      title={INFO_ELIMINAR}
                      onConfirm={() =>
                        eliminarRegistroExpLaboral(item.idExpAspirante)
                      }
                      okText="Aceptar"
                      cancelText="Cancelar"
                    >
                      <Button
                        id="bntCircle"
                        shape="circle"
                        icon={<DeleteOutlined />}
                      />
                    </Popconfirm>
                  </>
                )}
              </Col>
            </Row>

            <p>
              <label
                style={{
                  color: "gray",
                  fontWeight: "normal",
                  fontSize: "18px",
                }}
              >
                {item.fhInicio == null
                  ? "N/A"
                  : moment(item.fhInicio).format(DATE_FORMAT).toString()}
                {" - "}
                {item.fhFin == null
                  ? "Actual"
                  : moment(item.fhFin).format(DATE_FORMAT).toString()}
              </label>
            </p>

            <InfoAcademica
              subTitulo="Área"
              respuesta={obtenerDescExperiencia(item.idAreaExp)}
            />

            <InfoAcademica subTitulo="Empresa" respuesta={item.nombreEmpresa} />

            <InfoAcademica
              subTitulo="Remuneracion"
              respuesta={obtenerDescRemuneracion(item.idRemuneracion)}
            />

            {/* <Collapse ghost expandIconPosition={"left"}> */}
            <Collapse
              ghost
              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
            >
              <Panel
                header={
                  <div className="sub-titulo-academico">
                    <div style={{ textDecoration: "underline" }}>
                      Funciones: <span>Ver detalle...</span>
                    </div>
                  </div>
                }
                key={item.id}
              >
                <div
                  style={{
                    color: "gray",
                    fontWeight: "normal",
                    fontSize: "14px",
                  }}
                >
                  {item.funciones}
                </div>
              </Panel>
            </Collapse>
          </Timeline.Item>
        ))}
        <Timeline.Item>
          <Button
            type="link"
            disabled={bloquearPorFecha || estatusPostulacion}
            className="btn-nuevo"
            onClick={showModal}
          >
            Agregar nueva experiencia
          </Button>

          {/* <span
            className="btn-nuevo"
            onClick={showModal}
            style={{ cursor: "pointer" }}
          >
            Agregar nueva experiencia
          </span> */}
        </Timeline.Item>
      </Timeline>
    </div>
  );
};
